export const SVG_NS = 'http://www.w3.org/2000/svg'

export function el<K extends keyof SVGElementTagNameMap>(
  name: K,
  attrs: Record<string, string | number> = {},
  ...children: (Node | string)[]
): SVGElementTagNameMap[K] {
  const node = document.createElementNS(SVG_NS, name)
  for (const [k, v] of Object.entries(attrs)) node.setAttribute(k, String(v))
  for (const c of children) node.append(c)
  return node
}

export function h<K extends keyof HTMLElementTagNameMap>(
  name: K,
  attrs: Record<string, string | number | boolean> = {},
  ...children: (Node | string | null | undefined)[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(name)
  for (const [k, v] of Object.entries(attrs)) {
    if (v === false || v == null) continue
    if (k === 'class') node.className = String(v)
    else if (k === 'text') node.textContent = String(v)
    else if (k.startsWith('data-') || k === 'role' || k === 'type' || k === 'href') node.setAttribute(k, String(v))
    else if (k in node) (node as any)[k] = v
    else node.setAttribute(k, String(v))
  }
  for (const c of children) if (c != null) node.append(c)
  return node
}

/** A rect with rounded ends at the data end only, square at the baseline. */
export function barPath(x: number, y: number, w: number, h: number, r: number): string {
  const radius = Math.max(0, Math.min(r, w / 2, h))
  const bottom = y + h
  return (
    `M ${x} ${bottom}` +
    ` L ${x} ${y + radius}` +
    ` Q ${x} ${y} ${x + radius} ${y}` +
    ` L ${x + w - radius} ${y}` +
    ` Q ${x + w} ${y} ${x + w} ${y + radius}` +
    ` L ${x + w} ${bottom} Z`
  )
}

export function linePath(points: [number, number][]): string {
  return points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'} ${x} ${y}`).join(' ')
}

export function areaPath(points: [number, number][], baseline: number): string {
  if (!points.length) return ''
  const first = points[0]!
  const last = points[points.length - 1]!
  return `${linePath(points)} L ${last[0]} ${baseline} L ${first[0]} ${baseline} Z`
}
